import { useHistory } from "react-router-dom";

export const useLicensesGoBack = () => {
  const history = useHistory();

  return () => {
    if (window.opener) {
      window.close();

      return;
    }

    if (window.history.length > 1) {
      history.goBack();

      return;
    }

    history.push("/staff/licenses");
  };
};
